import { useRouter } from 'next/router';
import styles from '@features/footer/components/LanguageSelect/LanguageSelect.styles';
import { ISiteTypesDataLanguage } from '@typescript/index';
type PropsType = {
  availableLanguages: Array<ISiteTypesDataLanguage>;
  onClose: () => void;
};
const LanguageDropdown = ({
  availableLanguages,
  onClose
}: PropsType) => {
  const router = useRouter();
  const changeLocale = async (language: ISiteTypesDataLanguage) => {
    onClose();
    if (router.locale !== language.code) {
      router.push('/', '/', {
        locale: language.code
      });
    }
  };
  return <div sx={styles.languageDropdown}>
      {availableLanguages.map(language => <button type="button" sx={styles.dropdownListItem} key={`${language.code}-${Math.random()}`} onClick={() => changeLocale(language)}>
          {language.name}
        </button>)}
    </div>;
};
export default LanguageDropdown;